/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotifyRetryRequireRequest
 */
export interface NotifyRetryRequireRequest {
    /**
     * 
     * @type {string}
     * @memberof NotifyRetryRequireRequest
     */
    credentialType?: string;
}

/**
 * Check if a given object implements the NotifyRetryRequireRequest interface.
 */
export function instanceOfNotifyRetryRequireRequest(value: object): boolean {
    return true;
}

export function NotifyRetryRequireRequestFromJSON(json: any): NotifyRetryRequireRequest {
    return NotifyRetryRequireRequestFromJSONTyped(json, false);
}

export function NotifyRetryRequireRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotifyRetryRequireRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'credentialType': json['credentialType'] == null ? undefined : json['credentialType'],
    };
}

export function NotifyRetryRequireRequestToJSON(value?: NotifyRetryRequireRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'credentialType': value['credentialType'],
    };
}

